export const REGEX_MOBILE_FORMAT = /^\+?[1-9][0-9\- ]{7,19}$/;
export const REGEX_PHONE_10DIGIT = /^(\+91-)?(\d{4}-\d{4}-\d{2}|\d{10})$/;
export const REGEX_MFIRM_MOBILE_FORMAT = /^\+?[1-9][0-9\- ]{7,19}$/;
export const REGEX_EMAIL_FORMAT = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]{1,}\.[a-zA-Z]{2,}$/;
export const REGEX_DELOITTE_EMAIL_FORMAT = /^((?!@deloitte.com).)*$/;

export enum SortOrder {
    ASC = 'asc',
    DESC = 'desc'
}

export enum ResponseStatus {
    NotAuthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    Conflict = 409,
    Gone = 410,
    InternalServerError = 500,
}


export enum BadgeReasonEnum {
    BadgeDamaged = 1,
    BadgeLost = 2,
    BadgeStolen = 3,
    InitialBadgeRequest = 4,
    PhotoUpdate = 5,
    NonDVisitor = 8,
    MemberFirmVisitor = 7,
    ContactIDCard = 6
}


export enum StorageKeys {
    RedirectUrl = 'redirectUrl',
    isNeedReloadHomeSite = 'isNeedReloadHomeSite',
    accessToken = 'accessToken',
    accessTokenExpiration = 'accessTokenExpiration',
    redirectPathname = 'redirectPathname',
}

export interface IFilters {
    [key: string]: Array<IIdValue<string, string>>;
}

export interface IIdValue<ITID, ITValue> {
    id: ITID;
    value: ITValue;
    checked: boolean;
}

export enum PhotoActionNames {
    Approve = 'approve',
    ResubmissionPending = 'resubmissionPending',
    FurtherReview = 'furtherReview',
    CancelPrehire = 'cancelPrehire',
    CancelRequest = 'cancelRequest'
}

export enum BadgeRequestFlow {
    Default = 'Badge request',
    Resubmission = 'Resubmit photo',
    Compliance='Photo Compliance request'
}

export enum BadgeRequestCountry {
    US = 'US',
    USI = 'USI',
}

export enum MobileBadgeRequest {
    Approve = 'approve',
    Cancel = 'cancel'
}
